import endOfWeek from '@teetsh/app/src/utils/time/endOfWeek';
import startOfWeek from '@teetsh/app/src/utils/time/startOfWeek';
import { CahierJournalView } from 'containers/CahierJournal/types';
import { getNextNthDayBasedOnWorkingDays } from 'utils/time';
import subDays from 'utils/time/subDays';

interface FromTo {
  from: Date;
  to: Date;
}

export function getFromAndTo(
  view: CahierJournalView,
  date,
  mutualWorkingDays: number[],
): FromTo {
  const sundayStart = mutualWorkingDays.includes(-1);
  if (view === 'week') {
    const start = startOfWeek(date, sundayStart);
    const last = endOfWeek(date, sundayStart);
    return {
      from: start,
      to: last,
    };
  }
  if (view === '2days') {
    return {
      from: date,
      to: subDays(
        getNextNthDayBasedOnWorkingDays(date, mutualWorkingDays, 2),
        1,
      ),
    };
  }
  return {
    from: date,
    to: date,
  };
}
